import { SET_INSTANCE } from '../constants'

const handleReducer = (type: string, payload?) => {
  return {
    type,
    payload,
  }
}

export const setInstance = instance => handleReducer(SET_INSTANCE, instance)
